import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import App from './App'
import ErrorBoundary from './ErrorBoundary'

// Thin bar that appears on top of everything when the device goes offline.
// Self-contained so it never interferes with App's own screens.
function OfflineBanner() {
  const [online, setOnline] = useState(navigator.onLine)
  useEffect(() => {
    const on = () => setOnline(true)
    const off = () => setOnline(false)
    window.addEventListener('online', on)
    window.addEventListener('offline', off)
    return () => { window.removeEventListener('online', on); window.removeEventListener('offline', off) }
  }, [])
  if (online) return null
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 99999,
      background: '#E05C5C', color: '#fff', textAlign: 'center',
      fontSize: '12px', fontWeight: 600, padding: '7px 12px',
      fontFamily: 'Inter, system-ui, sans-serif', letterSpacing: '0.3px',
    }}>
      📡 No internet — some things may not work
    </div>
  )
}
import PrivacyPolicy from './pages/PrivacyPolicy'
import RefundPolicy from './pages/RefundPolicy'
import TermsConditions from './pages/TermsConditions'
import CancellationPolicy from './pages/CancellationPolicy'
import PaymentPolicy from './pages/PaymentPolicy'
import FAQ from './pages/FAQ'
import AboutUs from './pages/AboutUs'
import Contact from './pages/Contact'
import DeleteAccount from './pages/DeleteAccount'
import ResetPassword from './pages/ResetPassword'
import ReviewsPolicy from './pages/ReviewsPolicy'
import SafetyHygiene from './pages/SafetyHygiene'
import NotificationsPolicy from './pages/NotificationsPolicy'

ReactDOM.createRoot(document.getElementById('root')).render(
  <ErrorBoundary>
  <OfflineBanner />
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/account" element={<App />} />
      <Route path="/account/*" element={<App />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/refund-policy" element={<RefundPolicy />} />
      <Route path="/terms-and-conditions" element={<TermsConditions />} />
      <Route path="/cancellation-policy" element={<CancellationPolicy />} />
      <Route path="/payment-policy" element={<PaymentPolicy />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/help" element={<Contact />} />
      <Route path="/delete-account" element={<DeleteAccount />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/reviews-policy" element={<ReviewsPolicy />} />
      <Route path="/safety-hygiene" element={<SafetyHygiene />} />
      <Route path="/notifications-policy" element={<NotificationsPolicy />} />
    </Routes>
  </BrowserRouter>
  </ErrorBoundary>
)